import { SingleLayoutContainerProps } from '../single-layout-container.model';
import { AddLayoutController } from './add.controller';

export const AddLayout = (props: SingleLayoutContainerProps): JSX.Element => {
  return <AddLayoutController {...props} />;
};
